import angular from 'angular';
import { default as docDataService } from 'app/services/data/doc.data.service';
import controller from './add-edit-document-dialog.controller';
import template from './add-edit-document-dialog.html';
import messagesTpl from './messages.required.html';
import documentAssociationDialog from '../dialog.documentAssociationDialog';
import someSelectedTpl from './services.some-selected.messages.html';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
} = library;

export class dialogService {
  getOptions($event, {
    folderId = null,
    documentId = null,
    customerId = null,
    serviceId = null,
    documentName = '',
    parentFolder = null,
    document = null,
    updateCallback = null
  }) {
    return {
      controller,
      controllerAs: 'addEditDocumentDialogVM',
      locals: {
        folderId,
        documentId,
        customerId,
        serviceId,
        documentName,
        parentFolder,
        document,
        updateCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.global.documentManagement.addEditDocumentDialog', [
  ssDialogService,
  loaderService,
  alerts,
  confirmDialog,
  documentAssociationDialog,
  docDataService,
])
  .service('addEditDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('messages.required.html', messagesTpl);
    $templateCache.put('services.some-selected.messages.html', someSelectedTpl);
  })
  .name;

console.log('app.components.global.documentManagement.addEditDocumentDialog created');
